import { Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { AppointmentStatusSlug } from "../../../_constants/appointment.ts";
import Loader from "../../../common/components/Loader";
import { ConfirmationForm } from "../components/ConfirmationForm.tsx";
import SelectAndConfirmationForm from "../components/SelectAndConfirmationForm.tsx";
import { IResponseAppointment } from "../reducers";
import { getAppointment } from "../services";

const ConfirmationContainer = () => {
  const params = useParams<{ id: string }>();
  const { isLoading, error, data } = useQuery<IResponseAppointment, Error>(
    ["appointment", params.id],
    () => getAppointment(params.id),
    { staleTime: Infinity },
  );

  if (isLoading) {
    return (
      <div className="bg-container">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-container">
        <Alert variant="danger">Erreur chargement des données : {error}</Alert>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="bg-container">
        <Alert variant="danger">
          Erreur de récupération des données :<br />
          Veuillez réessayer ultérieurement.
        </Alert>
      </div>
    );
  }

  if (data.appointment.isConfirmed) {
    return (
      <div className="bg-container">
        <Alert variant="success">Votre rendez-vous est déjà confirmé</Alert>
      </div>
    );
  }

  const isWaitingTenant =
    data.appointment.lastStatus.status.slug ===
    AppointmentStatusSlug.WAITING_TENANT;

  return !isWaitingTenant ? (
    <ConfirmationForm
      service={data.appointment.service}
      appointment={data.appointment}
      dwelling={data.appointment.service.dwelling}
      agency={data.agency}
    />
  ) : (
    <SelectAndConfirmationForm
      appointment={data.appointment}
      availabilities={data.availabilities}
      service={data.appointment.service}
    />
  );
};

export default ConfirmationContainer;
